import { StaticProvider } from '@angular/core';
import { FeatureServiceDef, provideFeature } from '@y42/feature';
import { Y42GitFolders } from '@y42/feature/git';
import { Y42Routes } from '@y42/feature/routing';
import { Y42FeatureType } from '@y42/json-schema';
import { VisualizationDashboardAclService, VisualizationDashboardService } from '@y42/visualization/dashboard';
import {
  VisualizationWidgetGitService,
  VisualizationWidgetQuery,
  VisualizationWidgetStore,
} from '@y42/visualization/widget';

export const VisualizationWidgetFeatureProviders: () => FeatureServiceDef = () => {
  return {
    FEATURE_TYPE: Y42FeatureType.VisualizationWidget,
    GIT_FOLDER: Y42GitFolders.VisualizationWidget,
    FEATURE_ROUTE: Y42Routes.VisualizationWidget,
    DETAIL_TABS: [],
    AbstractFeatureService: VisualizationDashboardService,
    AbstractFeatureQueryEntity: VisualizationWidgetQuery,
    AbstractFeatureEntityStore: VisualizationWidgetStore,
    AbstractFeatureGitService: VisualizationWidgetGitService,
    AbstractFeatureAclService: VisualizationDashboardAclService,
    AbstractFeatureChildQueryEntity: null,
  };
};

export function VisualizationWidgetProviders(): StaticProvider[] {
  return provideFeature(VisualizationWidgetFeatureProviders());
}
